import axios from "axios";
import { hashtagsSlice, callTypes } from "./hashtagsSlice";

const API_URL = process.env.REACT_APP_API_URL;
const { actions } = hashtagsSlice;

export const fetchHashtags = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  return axios
    .get(API_URL + "hash-tags")
    .then((response) => {
      dispatch(actions.hashtagsFetched({ hashtagsList: response.data }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.list }));
    });
};

export const fetchHashtagsByKeyword = async (keyword, dispatch) => {
  return axios
    .get(API_URL + "hash-tags", {
      params: { hashtag_contains: keyword },
    })
    .then((response) => {
      const unBannedHashtags = response.data.filter(
        (hashtag) => !hashtag.banned
      );
      dispatch(actions.hashtagsFetched({ hashtagsList: unBannedHashtags }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.list }));
    });
};

export const fetchHashtagsDetails = (hashtag) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.listDetails }));
  const decodedHashtag = decodeURIComponent(hashtag);
  return axios
    .get(API_URL + "posts/search", {
      params: { text: decodedHashtag },
    })
    .then((response) => {
      dispatch(
        actions.hashtagDetailsFetched({
          hashtagsPostsDetails: {
            posts: response.data.posts,
            hashtag: decodedHashtag,
          },
        })
      );
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.listDetails })
      );
    });
};

export const banHashtag = (hashtagReport) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.ban }));
  const body = {
    banned: !hashtagReport.banned,
  };
  return axios
    .put(API_URL + `hash-tags/${hashtagReport.id}`, body)
    .then((response) => {
      dispatch(actions.hashtagBanned({ hashtagBanned: response.data }));
    })
    .catch((err) =>
      dispatch(actions.catchError({ error: err, callType: callTypes.ban }))
    );
};
